/* eslint-disable tailwindcss/no-arbitrary-value */
'use client';

import classNames from 'classnames';
import { MaterialIcon } from 'components/modulab/MaterialIcon';
import { ReactNode } from 'react';
import { StandoutTypeConfig } from './types';

export const StandoutShell = (props: {
  bodyClassName?: string;
  bodyGradient: string;
  children: ReactNode;
  headerBgClass: string;
  icon: StandoutTypeConfig['icon'];
  title: string;
}) => {
  const { bodyClassName, bodyGradient, children, headerBgClass, icon, title } =
    props;

  return (
    <div className="flex flex-col overflow-hidden rounded-radius/card border border-gray-300 bg-white">
      <div
        className={classNames(
          'flex items-center gap-1 border-b border-borders/default px-spacing/gap/x py-spacing/gap/y-sm text-text/on-dark',
          headerBgClass,
        )}
      >
        <MaterialIcon className="font-light" icon={icon} />
        <h3 className="mhg-alpha-typography-title-2 text-text/on-dark">
          {title}
        </h3>
      </div>
      <div className={bodyClassName} style={{ background: bodyGradient }}>
        {children}
      </div>
    </div>
  );
};
